import React from "react";

// "Edit" on every list view (25 Oct 2026): opens that list's existing edit
// screen (to-do -> Update Todo, shopping list -> Edit Shopping List,
// CheckLister -> the "edit my checklist" flow). One look for all of them.
export default function EditListButton({ onClick, label = "Edit" }) {
  return (
    <button type="button" onClick={onClick} data-testid="list-edit"
      style={{ alignSelf: "center", padding: "10px 28px", borderRadius: "10px", border: "none", background: "#2563EB", color: "#fff", fontSize: "14px", fontWeight: 700, cursor: "pointer" }}>
      ✏️ {label}
    </button>
  );
}
